import React from "react";
import "./Login.css";
import { Link, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import logo from "./login-logo.png";
import AuthService from "../services/auth.service";
import { useStateContext } from "../contexts/ContextProvider";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const form = useRef();
  const checkBtn = useRef();
  const [showPassword, setShowPassword] = useState(false);

  const {isLoggedIn, setIsLoggedIn} = useStateContext();

  const navigate = useNavigate();

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const data = {
      username: email,
      password: password,
      controllerId: "",
      posting: "1",
      department: "01",
    };

    setMessage("");
    setLoading(true);

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      setMessage("Please fill all the required details!");
      return;
    }

    AuthService.login(data).then(
      (response) => {
        if (response) {
          navigate("/dutylist");
          window.location.reload();
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        setMessage("Invalid Details");
      }
    );
  };

  return (
    <div className="login-container">
      <div className="main-container">
        <div className="left-container">
          <img className="login-logo" src={logo} alt="logo" />
        </div>
        <div className="vr-line"></div>
        <div className="right-container">
          <div className="hr-line"></div>
          <div className="heading">Login as a Admin User</div>
          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
          {/* <div> */}
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            ref={form}
            className="form-conatiner"
          >
            <Form.Group className="col-mb3 form-group">
              <input
                type="text"
                placeholder="User Name"
                value={email}
                onChange={onChangeEmail}
                required
                className="inputField"
                validations={[required]}
              />
            </Form.Group>
            <Form.Group className="form-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={onChangePassword}
                required
                className="inputField"
                style={{ marginBottom: 20 }}
                validations={[required]}
              />
            </Form.Group>
            <button className="login-btn">LOGIN</button>
          </Form>
          {/* <div className="fgt-pass">
            <Link className="pass" to="/forgotPassword">
              Forgot your Password?
            </Link>
      
          </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export default Login;
